import classNames from 'classnames';
import { isBetterHost, isIframeTurkeyHost } from '../../hostsConfig';
import { ReactComponent as LogoIcon } from '../../svg/logo-new.svg';

function Logo({ currentTheme, refresh }) {
  return isBetterHost ? (
    <img
      alt="logo"
      width={75}
      height={26}
      className="logo header-item"
      src="/beter_esports_primary_logo.png"
      onClick={refresh}
    />
  ) : (
    <div
      className={
        classNames(
          'logo header-item',
          {
            'blue': currentTheme === 'brand2' && !isIframeTurkeyHost,
            'light-green': currentTheme === 'brand176',
            'pink': currentTheme === 'brand177',
            'red': currentTheme === 'brand179',
            'green': currentTheme === 'brand181',
            'yellow': currentTheme === 'brand183' || isIframeTurkeyHost
          }
        )
      }
      onClick={refresh}
    >
      <LogoIcon />
    </div>
  );
}

export default Logo;
